import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { Picture } from '@/components/wpl/image/src/image';
import { Row } from '@/libraries/wpl/foundations/src/grid';

const Workflow = () => {
	return (
		<section css={section}>
			<Row layout="6-6" alignItems="center">
				<div>
					<h2 css={bodyContent}>
						<FormattedMessage
							id="JiraProductDiscoveryPage.workflow.heading"
							defaultMessage="Connect your entire workflow with Jira"
						/>
					</h2>
					<p>
						<FormattedMessage
							id="JiraProductDiscoveryPage.workflow.body.text"
							defaultMessage="From strategy and ideation through planning and delivery, bring your entire software lifecycle together in Jira"
						/>
					</p>
				</div>
				<Picture
					image={{
						src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1036e8r078n724ru6bb24rdl38bot0iu.webp',
						alt: '',
					}}
					css={img}
				/>
			</Row>
		</section>
	);
};

export default Workflow;

const section = css({
	width: '100%',
	background: token('color.background.neutral'),
	marginInline: 'auto',
	paddingBlock: token('space.600'),
	[media.above.md]: {
		borderRadius: '1.25rem',
	},
	[media.only.md]: {
		width: 'calc(100% - 64px)',
	},
	[media.above.lg]: {
		paddingInline: token('space.400'),
		width: 'max-content',
	},
});
const img = css({
	// need to target underlying img element
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	img: {
		maxWidth: '100%',
		height: 'auto',
	},
});
const bodyContent = css({
	marginBlock: 0,
});
